import en from "./en-US.json";
import es from "./es-ES.json";
import pt from "./pt-BR.json";

export const languages = {
  "en-US": en,
  "es-ES": es,
  "pt-BR": pt,
};
